import React from 'react';
import PropTypes from 'prop-types';

import { Segment } from 'semantic-ui-react';

import SegmentHeader from './segment_header';

// TODO: remove usage of routeName as it's no longer used
const SignedinConfirmation = (props) => {
  const { children, routeName } = props;
  return (
    <Segment className="center-card">
      <SegmentHeader routeName={routeName} />

      <div className="re is-padding-16px is-wordWrap-break-word">
        {children}
      </div>
    </Segment>
  );
};

SignedinConfirmation.propTypes = {
  routeName: PropTypes.string.isRequired,
  children: PropTypes.node,
};

SignedinConfirmation.defaultProps = {
  children: undefined,
};

export default SignedinConfirmation;
